<section class="gradient-section-theme-color1">
  <div class="container">
    <h1>
      Date and Time Tools
    </h1>
  </div>
</section>

<div class="col-xs-12" style="height:50px;"></div>

<div class="container">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/">Home</a></li>
      <li class="breadcrumb-item"><a href="/tools">Tools</a></li>
      <li class="breadcrumb-item active" aria-current="page">Date and Time Tools</li>
    </ol>
  </nav>

  <div class="mt-5">
    <div class="card mt-5">
      <div class="card-header">
        <h3>Date and Time Difference Calculator</h3>
      </div>
      <div class="card-body">
        <p>Use this tool to calculate the difference between two dates and times. Enter the start and
          end dates and times to see the difference in days, hours, minutes, and seconds, as well as a
        human-readable format.</p>
        <form (ngSubmit)="calculateDifference()" #dateTimeForm="ngForm">
          <div class="form-group">
            <label for="startDate">Start Date and Time:</label>
            <input type="datetime-local" class="form-control" id="startDate" name="startDate"
              [(ngModel)]="startDate" required ngModel>
          </div>

          <div class="form-group">
            <label for="endDate">End Date and Time:</label>
            <input type="datetime-local" class="form-control" id="endDate" name="endDate"
              [(ngModel)]="endDate" required ngModel>
          </div>


          <div class="form-group mt-3">
            <button type="button" class="btn btn-info" (click)="setEndDateToToday()">Set End Date
            and Time to Now</button>
          </div>

          <div class="form-group mt-3">
            <button type="submit" class="btn btn-primary">Calculate</button>
            <button type="button" class="btn btn-secondary" (click)="resetForm()">Reset</button>
          </div>
          <div class="alert alert-warning mt-3" role="alert">
            Please note that specifying the time is also required for the calculations.
          </div>
        </form>

        @if (dateTimeForm.submitted) {
          <div class="mt-3">
            <p>Calculating Difference between <strong>{{ startDate }}</strong> and <strong>{{ endDate
          }}</strong></p>
        </div>
      }

      @if (dateTimeForm.submitted) {
        <div class="mt-3">
          <h3>Difference in Days</h3>
          <div class="mt-3">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Days</th>
                  <th>Hours</th>
                  <th>Minutes</th>
                  <th>Seconds</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ difference.days }}</td>
                  <td>{{ difference.hours }}</td>
                  <td>{{ difference.minutes }}</td>
                  <td>{{ difference.seconds }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          @if (dateTimeForm.submitted) {
            <div class="mt-3">
              <h3>Difference in Human Readable Format</h3>
              <table class="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Years</th>
                    <th>Months</th>
                    <th>Days</th>
                    <th>Hours</th>
                    <th>Minutes</th>
                    <th>Seconds</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ differenceHumanReadable.years }}</td>
                    <td>{{ differenceHumanReadable.months }}</td>
                    <td>{{ differenceHumanReadable.days }}</td>
                    <td>{{ differenceHumanReadable.hours }}</td>
                    <td>{{ differenceHumanReadable.minutes }}</td>
                    <td>{{ differenceHumanReadable.seconds }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

</div>

<div class="col-xs-12" style="height:50px;"></div>
